import { Enums } from '../common/enums'
import { DataType } from '../../helpers/common-helper'
import { Utils } from '../util/utils'
import { DataProvider } from '../../helpers/data-provider'
import { Dictionary } from '../../helpers/dictionary'
import { CommonHelper } from '../../helpers/common-helper'

import { OpDescr } from '../core/op-descr'
import { OpFile } from '../core/op-file'
import { OpSchemaElement } from './op-schema-element'

export class OpSchema {
    //Properties
    public schema: number[] | string
    public idObject: any
    public referenceType: Enums.ReferenceType
    public width: number
    public height: number
    public indexNbr: number
    public class: Enums.LocationSchemaClass

    //Properties end

    //NavigationProperties
    public schemaConfiguration: OpSchemaElement[]
    //NavigationProperties end
    
    constructor(opObj: any) {
        if (opObj) {
            this.schema = opObj.Schema
            this.idObject = opObj.IdObject
            this.referenceType = opObj.ReferenceType
            this.width = opObj.Width
            this.height = opObj.Height
            this.class = opObj.Class
            this.indexNbr = opObj.IndexNbr
            if (opObj.SchemaConfiguration)
                this.schemaConfiguration = opObj.SchemaConfiguration.map(data => new OpSchemaElement(data))
        }
        if (!this.schemaConfiguration)
            this.schemaConfiguration = []
    }
    public toJSON(): any
    {
        return {
            Schema: this.schema,
            IdObject: this.idObject,
            ReferenceType: this.referenceType,
            Width: this.width,
            Height: this.height,
            Class: this.class,
            IndexNbr: this.indexNbr
        }
    }
}